import Button, { ButtonProps } from "./Button";
import Icon from "../Icon";
import { setActiveBuyBonus } from "../../store/slices/buy-bonus";
import { openModal } from "../../store/slices/modals";
import { useDispatch } from "react-redux";
import { useAppSelector, useBuyBonusConfig } from "../../hooks";
import { selectButton } from "../../store/slices/buttons";
import { getClasses, compareState } from "../../utils";
import classes from "../../styles/Buttons.module.css";

const BuyBonusButton: React.FC<ButtonProps> = (props) => {
  const { available, disabled, hidden, lang } = useAppSelector(
    (state) => ({
      ...selectButton("buyBonus", state),
      lang: state.details.language,
    }),
    compareState.bind(null, ["available", "disabled", "hidden"])
  );
  const dispatch = useDispatch();
  const { bonuses } = useBuyBonusConfig();

  const onClick = () => {
    const keys = Object.keys(bonuses);
    if (keys.length > 1) {
      dispatch(openModal("selectBuyBonus"));
    } else if (keys.length === 1) {
      dispatch(setActiveBuyBonus(keys[0]));
      dispatch(openModal("buyBonus"));
    }
  };

  const animations = {
    hoverIn: {
      duration: 0.2,
      scale: 1.04,
      y: "-10",
      ease: "circ.out",
    },
    hoverOut: {
      duration: 0.2,
      scale: 1.0,
      y: "0",
      ease: "power3.out",
    },
  };

  const iconType = lang === "en_sc" ? "BuyBonusSocial" : "BuyBonus";
  const iconSize = lang === "en_sc" ? 29 : 34;

  return (
    <Button
      name="buy-bonus"
      disabled={disabled}
      className={getClasses(classes, props.className, "buy-bonus")}
      onClick={onClick}
      available={available}
      hidden={hidden}
      animations={animations}
      soundEffect="button-click"
    >
      <svg viewBox="0 0 29.104166 29.104167">
        <defs>
          <linearGradient id="bb-gradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#e39c0f" />
            <stop offset="47%" stopColor="#ffbf00" />
            <stop offset="100%" stopColor="#d92225" />
          </linearGradient>
        </defs>
        <path
          d="M 14.552083,-1.75e-6 A 14.552083,14.552083 0 0 0 9.9999994e-8,14.552078 14.552083,14.552083 0 0 0 14.552083,29.104168 14.552083,14.552083 0 0 0 29.104166,14.552078 14.552083,14.552083 0 0 0 14.552083,-1.75e-6 Z m 0,0.92604 A 13.626041,13.626041 0 0 1 28.178125,14.552078 13.626041,13.626041 0 0 1 14.552083,28.178118 13.626041,13.626041 0 0 1 0.92604175,14.552078 13.626041,13.626041 0 0 1 14.552083,0.92603825 Z"
        />
      </svg>
      <Icon size={iconSize} type={iconType} />
    </Button>
  );
};

export default BuyBonusButton;
